// extracted by mini-css-extract-plugin
export default {"interestBarContainer":"InterestBar_interestBarContainer__-Mz1K","percentage":"InterestBar_percentage__ijKlV"};